import { render } from "./AddPeopleToAccountDialog.vue?vue&type=template&id=61ea9b1c"
import script from "./AddPeopleToAccountDialog.vue?vue&type=script&lang=js"
export * from "./AddPeopleToAccountDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__